import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import httpService from "../services/httpService";

const AuthContext = createContext<any>(null);

export const AuthProvider = ({ children }: any) => {
    const [user, setUser] = useState<any>(() => {
        const cached = localStorage.getItem("user");
        if (!cached) return null;
        try {
            return JSON.parse(cached);
        } catch {
            localStorage.removeItem("user");
            return null;
        }
    });

    const logout = useCallback(() => {
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");
        setUser(null);
    }, []);

    const fetchUser = useCallback(async () => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            setUser(null);
            return;
        }

        try {
            const res = await httpService.get("/user/me");

            // API returns an array — extract the first user object
            const userData = Array.isArray(res) ? res[0] : res;

            if (userData) {
                setUser(userData);
                localStorage.setItem("user", JSON.stringify(userData));
            } else {
                setUser(null);
            }
        } catch {
            logout();
        }
    }, [logout]);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    useEffect(() => {
        if (user) {
            localStorage.setItem("user", JSON.stringify(user));
        } else {
            localStorage.removeItem("user");
        }
    }, [user]);

    // 🔥 THIS IS THE KEY FIX
    const value = useMemo(
        () => ({
            user,
            setUser,
            fetchUser,
            logout,
        }),
        [user, fetchUser, logout]
    );

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);